import React, { useEffect, useState } from "react";
import { Box, Button, Modal, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./EventConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 480,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 34px 34px",
  outline: "none",
};

export const RejectInviteReasonModal = ({
  open,
  onClose,
  onConfirm,
  confirming = false,
  employeeName = "",
  count = 1,
}) => {
  const [reason, setReason] = useState("");

  useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  const handleClose = () => {
    if (confirming) return;
    onClose?.();
  };

  const handleConfirm = () => {
    const trimmed = reason.trim();
    if (!trimmed) return;
    onConfirm?.(trimmed);
  };

  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : handleClose}
      aria-labelledby="reject-invite-reason-title"
    >
      <Box sx={modalStyle} className="event-confirm-modal">
        <button
          type="button"
          className="event-confirm-modal__close"
          onClick={handleClose}
          disabled={confirming}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>

        <h2 id="reject-invite-reason-title" style={{ textAlign: "center" }}>
          Reject Invite?
        </h2>
        <p className="event-confirm-modal__body" style={{ textAlign: "center" }}>
          Provide a reason for rejecting
          {count > 1
            ? ` ${count} invitations`
            : employeeName
              ? ` ${employeeName}'s invitation`
              : " this invitation"}
          . This will be visible to admins.
        </p>

        <TextField
          fullWidth
          multiline
          minRows={3}
          placeholder="Enter rejection reason..."
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={confirming}
          inputProps={{ maxLength: 1000 }}
          sx={{ mb: 3 }}
        />

        <div className="event-confirm-modal__actions">
          <Button
            type="button"
            variant="contained"
            className="event-confirm-modal__btn-muted"
            disableElevation
            onClick={handleClose}
            disabled={confirming}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant="contained"
            className="event-confirm-modal__btn-primary"
            disableElevation
            onClick={handleConfirm}
            disabled={confirming || !reason.trim()}
          >
            {confirming ? "Saving…" : "Reject Invite"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
